<template lang='pug'>
  .th.fp-tree-cell.fp-tree-header(:class='getClass()',@click="$emit('click')", :style="{ width: grow }")
    i.sort-icon.fpui(:class="{'fpui-chevron-down':sorted.reverse,'fpui-chevron-up':!sorted.reverse}",v-if="sorted.index===index")
    span {{ column.label}}
</template>

<script>

export default {
  props: {
    columnItem: { type: Object, required: true },
    columnRatio: { type: Number },
    index: { type: Number, require: true },
    sorted: { type: Object, required: true },
    column: { type: Object, required: true }
  },
  methods: {
    getClass () {
      let cls = this.column.class || ''
      if (this.column.sortable) cls += ' fp-tree-header-sortable'
      return cls
    }
  },
  computed: {
    grow () {
      let grow = this.columnItem && this.columnItem.grow || 1
      return `${grow / this.columnRatio * 80}%`
    }
  }
}
</script>
